'use strict';

wbApp.controller('ActivityReconciliationDetailCtrl', ['$scope', '$filter', 'messageBoxSvc', 'activityReconciliationSvc',
function ($scope, $filter, messageBoxSvc, activityReconciliationSvc) {

    $scope.detailTabs = [
        {
            title: 'TXT_MAIN',
            template: "activities/activity-reconciliation-detail-main-tab.html"
        },
        {
            title: 'TXT_LBL_EXCUSES',
            template: "activities/activity-reconciliation-detail-excuse-tab.html"
        },
        {
            title: 'TXT_LBL_ATTENDANCE',
            template: "activities/activity-reconciliation-detail-attendance-tab.html"
        },
        {
            title: 'TXT_LBL_NOTE',
            template: "activities/activity-reconciliation-detail-notes-tab.html"
        },
        {
            title: 'TXT_PRICE_TAB',
            template: "activities/activity-reconciliation-detail-invoice-tab.html"
        }
    ];

    $scope.detailTabs.activeTab = 0;

    $scope.gridOptions = {
        sortInfo: { fields: ['date'], directions: ['asc'] },
        columnDefs: [
            { field: 'date', cellFilter: "date:'EEE d. M. '", displayName: "Den" },
            { field: 'firstPeriod', displayName: "Dopoledne", width: '95px' },
            { field: 'lunch', displayName: "Oběd", width: '55px' },
            { field: 'firstPeriodAttendanceStatus', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_STATUS", width: '80px' },
            { field: 'firstPeriodAttendanceType', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_TYPE", width: '90px' },
            { field: 'secondPeriod', displayName: "Odpoledne", width: '95px' },
            { field: 'secondPeriodAttendanceStatus', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_STATUS", width: '80px' },
            { field: 'secondPeriodAttendanceType', cellFilter: 'translate', displayName: "TXT_COL_ATTENDANCE_TYPE", width: '90px' }
        ],
        noCommandColumn: true,
        hideFooter: false,
        multiSelect: true,
        disabledField: 'reconciled'
    };

    $scope.reconcileMinDate = new Date();
    $scope.reconcileMaxDate = new Date();
    $scope.reconcileFrom = $scope.reconcileMinDate;
    $scope.reconcileTo = $scope.reconcileMaxDate;
    $scope.reconciliation = activityReconciliationSvc.getReconciliationDetail($scope.activityID, $scope.studentID, $scope.activityReconciliationID);
    $scope.reconciliationNameChanged = false;
    $scope.tariffFullName = '';
    $scope.tariffTypeID = 0;

    $scope.reconciliation.$promise.then(function () {
        $scope.reconcileMinDate = activityReconciliationSvc.getMinDateRange($scope.reconciliation.attendance);
        $scope.reconcileMaxDate = activityReconciliationSvc.getMaxDateRange($scope.reconciliation.attendance);
        $scope.tariffTypeID = $scope.reconciliation.activityStudentSetting && $scope.reconciliation.activityStudentSetting.activityTariffID
            ? $scope.reconciliation.activityStudentSetting.activityTariffTypeID
            : 0;
        $scope.tariffFullName = $scope.reconciliation.activityStudentSetting && $scope.reconciliation.activityStudentSetting.activityTariffID
            ? $scope.reconciliation.activityStudentSetting.tariffName + ' (' + $filter('wbCurrencyFlt')($scope.reconciliation.activityStudentSetting.tariffPrice) + ')'
            : '';
        if (!$scope.reconciliation.activityReconciliationID) {
            // New reconciliation
            $scope.reconciliationOrig = angular.copy($scope.reconciliation);

            $scope.reconcileFrom = moment($scope.reconcileMinDate).add(1, "days").startOf('day').toDate();
            $scope.reconcileTo = activityReconciliationSvc.getToDateRange(
                $scope.reconciliation.attendance, $scope.reconcileFrom, $scope.reconcileMaxDate);

            $scope.reconciliation.tariffFrom = moment($scope.reconcileFrom).add(1, "month").startOf('day').toDate();
            $scope.reconciliation.tariffTo = moment($scope.reconcileTo).add(1, "month").startOf('day').toDate();

            activityReconciliationSvc.selectDateRange($scope.reconciliation.attendance, $scope.reconcileFrom, $scope.reconcileTo);
            $scope.reconciliation.name = activityReconciliationSvc.getReconciliationName($scope.reconcileFrom, $scope.reconcileTo);
        } else {
            $scope.reconcileFrom = null;
            for (var i = 0; i < $scope.reconciliation.attendance.length; i++) {
                var attendance = $scope.reconciliation.attendance[i];
                if (attendance.isSelected) {
                    $scope.reconcileTo = moment(attendance.date).startOf('day').toDate();

                    if (!$scope.reconcileFrom) {
                        $scope.reconcileFrom = moment(attendance.date).startOf('day').toDate();
                    }
                }
            }
            $scope.reconciliationOrig = angular.copy($scope.reconciliation);
        }
    });

    $scope.rangeChanged = function (from, to) {
        activityReconciliationSvc.selectDateRange($scope.reconciliation.attendance, from, to);
        $scope.reconciliation.resetFields.call($scope.reconciliation);

        if (!$scope.reconciliationNameChanged) {
            $scope.reconciliation.name = activityReconciliationSvc.getReconciliationName(from, to);
        }
    }
    
    $scope.tariffRangeChanged = function () {
        $scope.reconciliation.recalculateTariffPrice.call($scope.reconciliation);
    }

    $scope.onReconciliationNameChange = function(newName) {
        $scope.reconciliationNameChanged = true;
    }

    $scope.onSelectionChanged = function (data) {
        $scope.reconciliation.resetFields.call($scope.reconciliation);
    }

    $scope.isSaveDisabled = function () {
        return $scope.reconciliation.isInvoiceEmpty ||
               angular.equals($scope.reconciliation, $scope.reconciliationOrig);
    }

    $scope.saveChanges = function () {

        if ($scope.isSaving) {
            return;
        }

        $scope.isSaving = true;

        messageBoxSvc.showMessageDlg({
            title: 'TXT_TITLE_CONFIRM_CLIENT_NOTIFICATION',
            message: 'TXT_TEXT_CONFIRM_CLIENT_NOTIFICATION',
            buttons: [{
                text: 'TXT_BTN_NO',
                callback: onNoClicked 
            }, {
                text: 'TXT_BTN_YES',
                callback: onYesClicked 
            }]
        });

        function onYesClicked() {
            if ($scope.reconciliation.activityReconciliationID) {
                activityReconciliationSvc.updateReconciliationDetail(
                    $scope.reconciliation,
                    true,
                    success,
                    error);
            } else {
                activityReconciliationSvc.insertReconciliationDetail(
                    $scope.reconciliation,
                    true,
                    success,
                    error);
            }
        }

        function onNoClicked() {
            if ($scope.reconciliation.activityReconciliationID) {
                activityReconciliationSvc.updateReconciliationDetail(
                    $scope.reconciliation,
                    false,
                    success,
                    error);
            } else {
                activityReconciliationSvc.insertReconciliationDetail(
                    $scope.reconciliation,
                    false,
                    success,
                    error);
            }
        }

        function success() {
            $scope.$emit('activityReconciliationDetailSaved', {});
            $scope.$hide();
        }

        function error(errorResult) {
            $scope.detailError = errorResult;
            $scope.isSaving = false;
        }
    }

}]);